export const selector = '.small-asset'

export default (
    el = null
) => {
    if (!el)
        return

    const modal = el.querySelector('.modal')

    if (!modal)
        return

    console.groupCollapsed('Small Asset')

    const embed = modal.querySelector('iframe')

    if (!embed)
        return

    const { src } = embed

    modal.addEventListener('hidden.bs.modal', () => {
        embed.setAttribute('src', '')
    })

    modal.addEventListener('show.bs.modal', () => {
        if (src && embed.src !== src)
            embed.setAttribute('src', src)
    })

    // Log els
    console.log(el)

    console.groupEnd()

    return el
}
